/* ============================================================
   DRIPIL 2.0 — התנהגות
   עגלה (AJAX) · תפריט · נגישות · וואטסאפ · סינון אמנים · עמוד מוצר
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.DRIPIL || {};
  // הסף הוא סכום באגורות (19900 = ₪199), לא כמות פריטים.
  var FREE_CENTS = parseInt(CFG.freeShipCents, 10) || 19900;
  var MONEY = CFG.moneyFormat || '₪{{amount}}';
  var ROOT = (CFG.rootUrl || '/').replace(/\/$/, '');

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var body = document.body;

  /* ---------- כסף ---------- */
  function money(cents) {
    var n = (cents || 0) / 100;
    var whole = n % 1 === 0;
    var s = whole ? String(n) : n.toFixed(2);
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/amount_no_decimals/.test(MONEY)) s = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, s);
  }

  /* ---------- נעילת גלילה ---------- */
  var locks = 0;
  function lock(on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    body.setAttribute('data-dp-lock', locks > 0 ? 'true' : 'false');
  }

  /* ============================================================
     תפריט מובייל
     ============================================================ */
  var sheet = $('[data-dp-menu]');
  function menu(open) {
    if (!sheet) return;
    sheet.setAttribute('data-open', open ? 'true' : 'false');
    sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    lock(open);
    if (open) { var f = sheet.querySelector('a, button'); if (f) f.focus(); }
  }
  $$('[data-dp-open-menu]').forEach(function (b) { b.addEventListener('click', function () { menu(true); }); });
  $$('[data-dp-close-menu]').forEach(function (b) { b.addEventListener('click', function () { menu(false); }); });
  if (sheet) $$('a', sheet).forEach(function (a) { a.addEventListener('click', function () { menu(false); }); });

  /* ============================================================
     עגלה
     ============================================================ */
  var drawer = $('[data-dp-cart]');
  var scrim  = $('[data-dp-scrim]');
  var cartBody = $('[data-dp-cart-body]');
  var cartFoot = $('[data-dp-cart-foot]');
  var shipWrap = $('[data-dp-ship]');
  var lastFocus = null;

  function cartOpen(open) {
    if (!drawer) return;
    if (open) lastFocus = document.activeElement;
    drawer.setAttribute('data-open', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (scrim) scrim.setAttribute('data-open', open ? 'true' : 'false');
    lock(open);
    if (open) { var c = $('[data-dp-close-cart]', drawer); if (c) c.focus(); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  $$('[data-dp-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refresh().then(function () { cartOpen(true); }); });
  });
  $$('[data-dp-close-cart]').forEach(function (b) { b.addEventListener('click', function () { cartOpen(false); }); });
  if (scrim) scrim.addEventListener('click', function () { cartOpen(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.getAttribute('data-open') === 'true') cartOpen(false);
    else if (sheet && sheet.getAttribute('data-open') === 'true') menu(false);
    else if (a11y && a11y.getAttribute('data-open') === 'true') a11yOpen(false);
  });

  function badge(count) {
    $$('[data-dp-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-empty', count === 0 ? 'true' : 'false');
      if (count > 0) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
    });
  }

  function shipBar(cents) {
    if (!shipWrap) return;
    var left = Math.max(0, FREE_CENTS - cents);
    var pct = Math.min(100, Math.round((cents / FREE_CENTS) * 100));
    var txt = $('[data-dp-ship-txt]', shipWrap);
    var fill = $('[data-dp-ship-fill]', shipWrap);
    if (left === 0) {
      txt.innerHTML = '✓ יש לך <b>משלוח חינם</b> על ההזמנה הזאת';
      txt.classList.add('is-done');
      fill.classList.add('is-done');
    } else {
      txt.innerHTML = 'עוד <b>' + money(left) + '</b> ותקבל משלוח חינם';
      txt.classList.remove('is-done');
      fill.classList.remove('is-done');
    }
    fill.style.width = pct + '%';
  }

  function lineHTML(item, i) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy" width="74" height="88">'
      : '';
    var opts = (item.options_with_values || [])
      .filter(function (o) { return o.value && !/default/i.test(o.value); })
      .map(function (o) { return o.value; }).join(' · ');
    return '' +
      '<div class="dp-line" data-dp-line data-key="' + item.key + '" data-i="' + (i + 1) + '">' +
        '<a class="dp-line-img" href="' + item.url + '">' + img + '</a>' +
        '<div class="dp-line-mid">' +
          '<a class="dp-line-name" href="' + item.url + '">' + item.product_title + '</a>' +
          (opts ? '<span class="dp-line-var">' + opts + '</span>' : '') +
          '<div class="dp-line-row">' +
            '<div class="dp-qty">' +
              '<button type="button" data-dp-qty="-1" aria-label="הפחתת כמות">−</button>' +
              '<span data-dp-qty-val>' + item.quantity + '</span>' +
              '<button type="button" data-dp-qty="1" aria-label="הוספת כמות">+</button>' +
            '</div>' +
            '<span class="dp-line-price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="dp-line-rm" data-dp-remove>הסרה</button>' +
        '</div>' +
      '</div>';
  }

  function emptyHTML() {
    return '' +
      '<div class="dp-cart-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
          '<path d="M5.5 8h13l-1.1 11.2a2 2 0 0 1-2 1.8H8.6a2 2 0 0 1-2-1.8L5.5 8Z"/><path d="M9 8V6.4a3 3 0 0 1 6 0V8"/>' +
        '</svg>' +
        '<p class="dp-lead" style="margin:0">הסל ריק. בוא נסדר את זה.</p>' +
        '<a class="dp-btn dp-btn--ink" href="' + ROOT + '/pages/shop">לחנות</a>' +
      '</div>';
  }

  function render(cart) {
    badge(cart.item_count);
    shipBar(cart.total_price);
    if (!cartBody) return;

    if (!cart.items.length) {
      cartBody.innerHTML = emptyHTML();
      if (cartFoot) cartFoot.hidden = true;
      if (shipWrap) shipWrap.hidden = true;
      return;
    }
    if (shipWrap) shipWrap.hidden = false;
    cartBody.innerHTML = cart.items.map(lineHTML).join('');
    if (cartFoot) {
      cartFoot.hidden = false;
      var t = $('[data-dp-total]', cartFoot);
      if (t) t.textContent = money(cart.total_price);
    }
  }

  function refresh() {
    return fetch(ROOT + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; })
      .catch(function () { return null; });
  }

  function change(key, qty, lineEl) {
    if (lineEl) lineEl.setAttribute('data-busy', 'true');
    return fetch(ROOT + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; })
      .catch(function () { if (lineEl) lineEl.removeAttribute('data-busy'); });
  }

  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var line = e.target.closest('[data-dp-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qBtn = e.target.closest('[data-dp-qty]');
      if (qBtn) {
        var cur = parseInt($('[data-dp-qty-val]', line).textContent, 10) || 0;
        var next = cur + parseInt(qBtn.getAttribute('data-dp-qty'), 10);
        change(key, Math.max(0, next), line);
        return;
      }
      if (e.target.closest('[data-dp-remove]')) change(key, 0, line);
    });
  }

  /* ---------- הוספה לסל ---------- */
  function addToCart(payload, btn) {
    var label = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'מוסיף…'; }
    return fetch(ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (!res.ok) { alert(res.j.description || res.j.message || 'לא הצלחנו להוסיף לסל'); return; }
        return refresh().then(function () { cartOpen(true); });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        alert('לא הצלחנו להוסיף לסל. נסה שוב.');
      });
  }

  // פתיחת בורר המידות על הכרטיס
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dp-open-sizes]');
    if (t) {
      e.preventDefault();
      var card = t.closest('.dp-card');
      var panel = $('[data-dp-card-sizes]', card);
      var open = t.getAttribute('aria-expanded') === 'true';
      $$('[data-dp-card-sizes]').forEach(function (o) { if (o !== panel) o.hidden = true; });
      $$('[data-dp-open-sizes]').forEach(function (o) { if (o !== t) o.setAttribute('aria-expanded', 'false'); });
      t.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
      return;
    }
    if (!e.target.closest('[data-dp-card-sizes]')) {
      $$('[data-dp-card-sizes]').forEach(function (o) { o.hidden = true; });
      $$('[data-dp-open-sizes]').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    }
  });

  // כפתור הוספה מהירה על כרטיס
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dp-add]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var id = b.getAttribute('data-dp-add');
    if (!id) return;
    addToCart({ items: [{ id: Number(id), quantity: 1 }] }, b);
  });

  // טופס מוצר
  $$('[data-dp-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var id = fd.get('id');
      if (!id) return;
      addToCart({ items: [{ id: Number(id), quantity: Number(fd.get('quantity') || 1) }] }, $('[data-dp-add-btn]', form));
    });
  });

  /* ---------- חיפוש בהדר ---------- */
  var searchPanel = $('#dp-search');
  $$('[data-dp-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!searchPanel) return;
      var open = !searchPanel.hidden;
      searchPanel.hidden = open;
      b.setAttribute('aria-expanded', String(!open));
      if (!open) { var i = $('input[name="q"]', searchPanel); if (i) i.focus(); }
    });
  });

  /* ============================================================
     נגישות
     ============================================================ */
  var a11y = $('[data-dp-a11y]');
  var KEY = 'dripil-a11y';
  var state = { fs: 1, contrast: false, links: false, motion: false, readable: false };

  try { var saved = JSON.parse(localStorage.getItem(KEY) || 'null'); if (saved) state = Object.assign(state, saved); } catch (err) {}

  function applyA11y() {
    document.documentElement.style.setProperty('--dp-fs', state.fs);
    body.setAttribute('data-a11y-contrast', String(state.contrast));
    body.setAttribute('data-a11y-links', String(state.links));
    body.setAttribute('data-a11y-motion', String(state.motion));
    body.setAttribute('data-a11y-readable', String(state.readable));
    $$('[data-dp-a11y-toggle]').forEach(function (b) {
      var k = b.getAttribute('data-dp-a11y-toggle');
      b.setAttribute('aria-pressed', String(!!state[k]));
    });
    var fsLbl = $('[data-dp-fs-val]');
    if (fsLbl) fsLbl.textContent = Math.round(state.fs * 100) + '%';
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (err) {}
  }

  function a11yOpen(open) {
    if (!a11y) return;
    a11y.setAttribute('data-open', open ? 'true' : 'false');
    a11y.setAttribute('aria-hidden', open ? 'false' : 'true');
    var t = $('[data-dp-a11y-btn]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var f = a11y.querySelector('button'); if (f) f.focus(); }
  }
  var a11yBtn = $('[data-dp-a11y-btn]');
  if (a11yBtn) a11yBtn.addEventListener('click', function () {
    a11yOpen(a11y.getAttribute('data-open') !== 'true');
  });
  $$('[data-dp-a11y-close]').forEach(function (b) { b.addEventListener('click', function () { a11yOpen(false); }); });

  $$('[data-dp-a11y-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-dp-a11y-toggle');
      state[k] = !state[k];
      applyA11y();
    });
  });
  $$('[data-dp-fs]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = parseFloat(b.getAttribute('data-dp-fs'));
      state.fs = Math.min(1.6, Math.max(0.9, Math.round((state.fs + d) * 100) / 100));
      applyA11y();
    });
  });
  var reset = $('[data-dp-a11y-reset]');
  if (reset) reset.addEventListener('click', function () {
    state = { fs: 1, contrast: false, links: false, motion: false, readable: false };
    applyA11y();
  });
  document.addEventListener('click', function (e) {
    if (!a11y || a11y.getAttribute('data-open') !== 'true') return;
    if (a11y.contains(e.target) || (a11yBtn && a11yBtn.contains(e.target))) return;
    a11yOpen(false);
  });
  applyA11y();

  /* ============================================================
     החנות — סינון לפי אמן
     ============================================================ */
  var chips = $$('[data-dp-chip]');
  if (chips.length) {
    var groups = $$('[data-dp-artist]');
    var countEl = $('[data-dp-shop-count]');
    function filter(key) {
      var shown = 0;
      groups.forEach(function (g) {
        var on = key === 'all' || g.getAttribute('data-dp-artist') === key;
        g.hidden = !on;
        if (on) shown += parseInt(g.getAttribute('data-count'), 10) || 0;
      });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-dp-chip') === key)); });
      if (countEl) countEl.textContent = shown;
      try { history.replaceState(null, '', key === 'all' ? location.pathname : location.pathname + '#' + key); } catch (err) {}
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        var key = c.getAttribute('data-dp-chip');
        // הצ'יפ הוא <a> לעמוד הקולקציה כדי שיעבוד גם בלי JS.
        // יש JS — מסננים כאן ולא עוזבים את העמוד.
        e.preventDefault();
        filter(key);
        if (key !== 'all') {
          var g = document.querySelector('[data-dp-artist="' + key + '"]');
          if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });
    var hash = (location.hash || '').replace('#', '');
    if (hash && document.querySelector('[data-dp-artist="' + hash + '"]')) filter(hash);
  }

  /* ============================================================
     עמוד מוצר
     ============================================================ */
  var pdp = $('[data-dp-pdp]');
  if (pdp) {
    var variants = [];
    try { variants = JSON.parse($('[data-dp-variants]', pdp).textContent); } catch (err) {}

    var mainImg = $('[data-dp-main-img]', pdp);
    $$('[data-dp-thumb]', pdp).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-dp-thumb]', pdp).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        if (mainImg) mainImg.src = t.getAttribute('data-dp-thumb');
      });
    });

    var idInput = $('[data-dp-variant-id]', pdp);
    var priceEl = $('[data-dp-price]', pdp);
    var addBtn  = $('[data-dp-add-btn]', pdp);

    // הבחירה הנוכחית לכל אפשרות (מידה, צבע, ...) לפי המיקום שלה במוצר
    var chosen = [];
    $$('[data-dp-opt-group]', pdp).forEach(function (g) {
      var i = Number(g.getAttribute('data-dp-opt-group'));
      var on = $('[data-dp-opt][aria-pressed="true"]', g);
      chosen[i] = on ? on.getAttribute('data-dp-val') : null;
    });

    function matchVariant() {
      return variants.filter(function (v) {
        return chosen.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }

    function pickVariant(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'הצירוף הזה אזל'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'הוספה לסל · ' + money(v.price) : 'אזל מהמלאי';
      }
      if (v.image && mainImg) mainImg.src = v.image;
    }

    // אפשרות שאין לה אף וריאנט זמין בהינתן שאר הבחירות — מסומנת כאזלה
    function refreshAvailability() {
      $$('[data-dp-opt]', pdp).forEach(function (btn) {
        var i = Number(btn.getAttribute('data-dp-opt'));
        var val = btn.getAttribute('data-dp-val');
        var possible = variants.some(function (v) {
          if (v.options[i] !== val) return false;
          return chosen.every(function (c, ci) { return ci === i || c == null || v.options[ci] === c; });
        });
        var inStock = variants.some(function (v) {
          if (v.options[i] !== val || !v.available) return false;
          return chosen.every(function (c, ci) { return ci === i || c == null || v.options[ci] === c; });
        });
        btn.disabled = !possible;
        btn.classList.toggle('is-out', possible && !inStock);
      });
    }

    $$('[data-dp-opt]', pdp).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var i = Number(btn.getAttribute('data-dp-opt'));
        var group = btn.closest('[data-dp-opt-group]');
        $$('[data-dp-opt]', group).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        chosen[i] = btn.getAttribute('data-dp-val');
        var label = $('[data-dp-opt-current="' + i + '"]', pdp);
        if (label) label.textContent = chosen[i];
        refreshAvailability();
        pickVariant(matchVariant());
      });
    });
    refreshAvailability();

    var buyNow = $('[data-dp-buy-now]', pdp);
    if (buyNow) buyNow.addEventListener('click', function () {
      var id = idInput ? idInput.value : null;
      if (!id) return;
      addToCart({ items: [{ id: Number(id), quantity: 1 }] }).then(function () {
        window.location.href = ROOT + '/checkout';
      });
    });
  }

  /* ---------- אקורדיונים (גם בעמוד מוצר וגם בתקנון) ---------- */
  $$('[data-dp-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
      var icon = btn.querySelector('[data-dp-acc-icon]');
      if (icon) icon.textContent = open ? '+' : '−';
    });
  });

  /* ---------- ההדר נעלם בגלילה למטה, חוזר בגלילה למעלה ---------- */
  var hdr = $('.dp-header');
  if (hdr) {
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.pageYOffset || 0;
        // לא מסתירים כשמגירה או תפריט פתוחים, ולא בראש העמוד
        var blocked = body.getAttribute('data-dp-lock') === 'true';
        if (!blocked && y > 140 && y > lastY + 6) hdr.setAttribute('data-hide', 'true');
        else if (y < lastY - 6 || y <= 140) hdr.removeAttribute('data-hide');
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- טעינה ראשונה ---------- */
  refresh();
  if (/[?&]dp-cart=1/.test(location.search)) setTimeout(function () { cartOpen(true); }, 250);
})();
